import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white" data-id="element-236">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-238">
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-239">
            Si tienes tu entrevista de ciudadanía americana programada y cada
            vez que piensas en ella sientes ese nudo en el estómago… esta página
            es para ti.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-240">
            Porque lo que estás sintiendo no es falta de inteligencia. No es
            falta de esfuerzo. Es algo mucho más específico:
          </p>
          <p className="text-xl sm:text-2xl font-semibold text-[#1B2A4A]" data-id="element-241">
            Nunca habías tenido un sistema diseñado exactamente para alguien
            como tú.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-242">
            Alguien que habla español como primer idioma. Alguien que lleva años
            trabajando duro en este país. Alguien que merece esa ciudadanía y
            sabe que está a una sola entrevista de conseguirla.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-243">
            El problema no eres tú. El problema es que la mayoría de materiales
            de preparación están hechos en inglés, son confusos, y no simulan lo
            que realmente pasa dentro de esa oficina.
          </p>
          <p className="text-2xl sm:text-3xl font-bold text-[#C9A84C] mt-8" data-id="element-244">
            Hoy eso cambia.
          </p>
        </motion.div>
      </div>
    </section>;
}